//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: '正在载入...'
    },
    color: {
    	type: String,
    	default: '#fff'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/no-more.vue